const { h, render, Component } = require('preact');

const LoggedInOtherIssuesView = (props) => (
      <div class="other-issues">
        <p>
          {I18n.translate("js.modules.web_2018.other_issues")}
        </p>
        <span onClick={props.handleFacebookOrderHelp} data-bhw="web2018_facebook_order_contacts_logged_in_link">
          {I18n.translate("js.modules.web_2018.facebook_order_contacts")}
        </span>
      </div>
    );
module.exports = LoggedInOtherIssuesView;
